// extracted by mini-css-extract-plugin
export var bodyRow = "_e6-d";
export var cardColumns = "_e6-e";
export var ellipsesOverflow = "_e6-2";
export var flatBottomCorners = "_e6-3";
export var flatTopCorners = "_e6-4";
export var headerActionsDropdown = "_e6-f";
export var headerBottomRow = "_e6-c";
export var headerTopRow = "_e6-b";
export var orderDetailsWrapper = "_e6-0";
export var orderInfoContainer = "_e6-1";
export var productDetails = "_e6-9";
export var productImage = "_e6-5";
export var responsiveTable = "_e6-8";
export var shipmentContainer = "_e6-a";
export var tableBottomLeft = "_e6-6";
export var tableBottomRight = "_e6-7";
export var trackingLink = "_e6-g";